module.exports = __webpack_public_path__ + "img/about-position-box1.jpg?3fafd39d74a94463d2eeb04561530c26";